import VideoCompiler     from 'descriptor/video_compiler';
import { getParams }     from 'utils/util';
import { flatten, get }       from '_';
import $                 from 'jquery';


const Compiler = function(descriptor) {
  this.descriptor = descriptor;
};

Compiler.prototype = {
  compile() {
    this.sniff();
    this.mediaCompiler.compile();
    this.descriptor.videos = this.mediaCompiler.getVideos();

    // If the property "events" exists then the Guided Video feature is active
    if(((this.descriptor.videos[0].hasOwnProperty('events')) ||
      (get(this, 'this.descriptor.videos[1].hasOwnProperty("events")', {}))) &&
      (this.descriptor.rememberMe === false)) {
      // If the Video Guided feature is active then we disable the startVideo feature
    } else {
      if(typeof getParams().startVideo !== 'undefined') {
        const inIndex = parseInt((getParams().startVideo - 1), 10);
        if(!isNaN(inIndex)) {
          this.descriptor.initialIndex = (inIndex > this.descriptor.videos.length || inIndex < 0)? 0: inIndex;
        }
      } else if(window.location.hash) {
        const hashIndex = parseInt((window.location.hash.substr(1) - 1), 10);
        if(!isNaN(hashIndex)) {
          this.descriptor.initialIndex = (hashIndex > this.descriptor.videos.length || hashIndex < 0)? 0: hashIndex;
        }
      }
    }

    // if tacticIndex is not null and is not greater than video length, then initialIndex = tacticIndex
    if(this.descriptor.tacticIndex && !(this.descriptor.tacticIndex > this.descriptor.videos.length)) {
        this.descriptor.initialIndex = this.descriptor.tacticIndex;
    }

    this.descriptor.lockChildren = flatten(this.descriptor.videos.map((inVideo)=> {
      if(Array.isArray(inVideo.events)) {
        const videoLockedChildren = inVideo.events.reduce((acc, val)=> {
          return acc.concat(val.lockChildren);
        }, []);
        return videoLockedChildren;
      } else {
        return [];
      }
    }));

    let cookieName = 'guidedVideo',
        lastUnlockedVideo = 1,
        lockCss = get(this, 'descriptor.videos[0].events[0].lockDisplay', ''),
        class_name = '',
        x = 2;

    // Gray-out or hide all the chapters except the first one
    if(lockCss === 'hide') {
      class_name = 'hide-playlist';
    } else if(lockCss === 'grayout') {
      class_name = 'gray-out';
    }

    lastUnlockedVideo = this.getCookie(cookieName);
    x = Number(lastUnlockedVideo) + 1;

    for(x+1; x<= $('.chapter-link-in-menu').length; x++) {
      $('#chapter-'+x).addClass(class_name);
    }


    this.descriptor.lockChildren = this.descriptor.lockChildren.filter((index)=>{
      return (index > lastUnlockedVideo);
    });

    if(!this.descriptor.initialIndex) {
      this.descriptor.initialIndex = 0;
    }
    return this;
  },
  sniff() {
    this.mediaCompiler      = new VideoCompiler(this.descriptor.videos, this.descriptor.ccInfo);
    this.descriptor.isVideo = true;
  },
  getDescriptor() {
    return this.descriptor;
  },
  getCookie(name) {
      let nameEQ = name + '=',
          ca = document.cookie.split(';'),
          i = 0, c = '';
      for(i; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return 1;
  }
};

export default Compiler;



// WEBPACK FOOTER //
// ./modules/descriptor/compiler.js